import api from '../api'
import store from '../store'
import router from '../router'
import fromApi from '../api/map-to-frontend'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'
import { errorPipeline } from '@/api/pipelines/error-pipeline.js'
import { getDefaultCompanyData, getUserCompanyData } from '@/api/company-data'
import { JSConn } from '@/utilities/js-conn.js'

const readToken = () => {
  return localStorage.getItem('token')
}

const tokenExists = () => {
  const token = localStorage.getItem('token')

  let apiToken = false

  if (token !== '') {
    apiToken = token
  } else {
    apiToken = false
  }

  return apiToken
}

const createUser = (jsConn) => {
  store.dispatch('updateUserSignupData', jsConn.formParams)

  return api.createUser(jsConn)
    .then(jsConn => {
      successPipeline(jsConn)
        .then(jsConn => {
          // const dataForStore = fromApi.userToStore(jsConn.response['data']['payload'])
          // store.dispatch('updateSession', dataForStore)
          router.push(jsConn.toRoutePath)
          return Promise.resolve(jsConn)
        })
        .catch(jsConn => {
          router.push(jsConn.toRoutePath)
          return Promise.resolve(jsConn)
        })
    })
    .catch(error => {
      return errorPipeline(error)
    })
}

const createSession = (jsConn) => {
  return api.signInUser(jsConn)
    .then(jsConn => {
      // check what we got back from the api call
      if (jsConn.apiCallStatus === 'success') {
        // api call was a success
        return successPipeline(jsConn)
          .then(jsConn => {
            const dataForStore = fromApi.userToStore(jsConn.response['data']['payload'])
            store.dispatch('updateSession', dataForStore)
            router.push(jsConn.toRoutePath)
            return Promise.resolve(jsConn)
          })
          .then(jsConn => {
            return getUserCompanyData(jsConn)
          })
          .then(jsConn => {
            router.push(jsConn.toRoutePath)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            // if the pipeline fails or something, catch it here
            router.push(jsConn.toRoutePath)
            return Promise.resolve(jsConn)
          })
      } else {
        // api call failed
        return errorPipeline(jsConn)
          .then(jsConn => {
            // there was an error
            // TODO process the messages properly
            router.push(jsConn.toRoutePath)
            return Promise.resolve(jsConn)
          })
      }
    })
}

const updateSession = (jsConn) => {
  const token = tokenExists()
  if (token) {
    jsConn.apiParams = { 'token': token }
    jsConn.toRoutePath = '/crops'
    return api.updateSession(jsConn)
      .then(jsConn => {
        if (jsConn.apiCallStatus === 'success') {
          successPipeline(jsConn)
            .then(jsConn => {
              // save the data
              // map the store data
              const dataForStore = fromApi.userToStore(jsConn.response['data']['payload'])
              store.dispatch('updateSession', dataForStore)

              if (dataForStore.signedIn) {
                // if the user is logged in, get their data
                return getUserCompanyData(jsConn)
                  .then(jsConn => {
                    router.push(jsConn.toRoutePath)
                    return Promise.resolve(jsConn)
                  })
                  .catch(jsConn => {
                    router.push(jsConn.toRoutePath)
                    return Promise.resolve(jsConn)
                  })
              } else {
                // if not, get the default data
                getDefaultCompanyData(jsConn)
                return Promise.resolve(jsConn)
              }
            })
            .catch(jsConn => {
              router.push(jsConn.toRoutePath)
              return Promise.resolve(jsConn)
            })
        } else {
          errorPipeline(jsConn)
          // there was an error with updating the session
          // delete the token and log out the user
          // and load the default data
            .then(jsConn => {
              api.deleteSession(token)
              store.dispatch('updateDefaultSession')
              return getDefaultCompanyData(jsConn)
                .then(jsConn => {
                  router.push(jsConn.toRoutePath)
                })
            })
        }
      })
  } else {
    // no token
    return getDefaultCompanyData(jsConn)
      .then(jsConn => {
        router.push(jsConn.toRoutePath)
      })
  }
}

const deleteSession = () => {
  const token = tokenExists()
  if (token) {
    api.deleteSession(token)
  }
  store.dispatch('updateDefaultSession')
  const jsConn = new JSConn()
  getDefaultCompanyData(jsConn)
}

const session = {
  updateSession,
  createSession,
  deleteSession,
  createUser,
  readToken
}

export default session
